import { useResource, useResources } from 'datx-jsonapi-react';
import { useRouter } from 'next/router';

import { queryThinEventSession } from '@/queries/thin-event-sessions';
import { queryLectures } from '@/queries/thin-lectures';

const sessionLocation = (sessionId: string, urlString: string) => {
  const url = new URL(urlString);

  url.searchParams.set('eventSessionId', sessionId);
  url.searchParams.delete('search');
  return url.href;
};

export const useAddToCalendarDescription = (sessionId: string) => {
  const router = useRouter();
  const { data: lectures } = useResources(queryLectures(sessionId));
  const url = process.env.NEXT_PUBLIC_BASE_URL + router.asPath.substring(1);

  const { data: eventSession } = useResource(queryThinEventSession(sessionId));

  const lectureBullets =
    lectures?.length > 0 ? `Lectures included:\n${lectures.map((l) => `- ${l.title}`).join('\n')}` : '';

  return `${eventSession?.name}

${sessionLocation(eventSession?.id, url)}

${eventSession?.description || ''}

${lectureBullets}`;
};
